/********************************
 * 
 *  mutations
 * 
 ********************************/

// request
//export const INSU_REQUEST_MUTATION = 'INSU_REQUEST_MUTAION';

// modal
//export const INSU_MODAL_MUTATION = 'INSU_MODAL_MUTATION';

// selecte insu
export const SELECT_INSU_MUTATION = 'SELECT_INSU_MUTATION';
/*export const RESET_SELECTED_MUTATION = 'RESET_SELECTED_MUTATION';

// set query
export const SET_QUERY_MUTATION = 'SET_QUERY_MUTATION';
export const RESET_QUERY_MUTATION = 'RESET_QUERY_MUTATION';

// set products
export const SET_PRODUCTS_MUTATION = 'SET_PRODUCTS_MUTATION';
export const RESET_PRODUCTS_MUTATION = 'RESET_PRODUCTS_MUTATION';
*/
/********************************
 * 
 *  actions
 * 
 ********************************/
/*
// fetch details for modal
export const FETCH_DETAILS_ACTION = 'FETCH_DETAILS_ACTION';

// fetch products of insurnace
export const FETCH_INSU_ACTION = 'FETCH_INSU_ACTION';

// handle scroll to product
export const HANDLE_PAGE_SCROLL = 'HANDLE_PAGE_SCROLL';
*/
// handle purchase
export const HANDLE_PURCHASE_ACTION1 = 'HANDLE_PURCHASE_ACTION1';